import { Icon as LegacyIcon } from "@circle-react-shared/Icon";
import { IconButton } from "@circleco/compass/components/IconButton";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";
import { getAnimationDelay } from "@/react/components/Spaces/AiSummary/animations";

interface NoPostsStateProps {
  onCollapseClick: () => void;
}

export const NoPostsStateV4 = ({ onCollapseClick }: NoPostsStateProps) => (
  <div className="absolute inset-0 flex items-center justify-center p-6">
    <IconButton
      icon="cross"
      size="sm"
      variant="secondary"
      aria-label={t("collapse")}
      onClick={onCollapseClick}
      className="absolute right-5 top-5 z-50"
    />

    <div className="flex h-full items-center justify-center p-6">
      <div className="flex flex-col items-center gap-4 text-center">
        <div
          className="animate-fade-in-slow opacity-0"
          style={{
            animationDelay: getAnimationDelay(1),
            animationFillMode: "forwards",
          }}
        >
          <LegacyIcon type="48-sun" size={48} className="scale-[2.5]" />
        </div>
        <div className="space-y-2">
          <div
            className="animate-fade-in-slow opacity-0"
            style={{
              animationDelay: getAnimationDelay(2),
              animationFillMode: "forwards",
            }}
          >
            <Typography variant="heading-md">
              {t("ai_spaces_summaries.all_caught_up")}
            </Typography>
          </div>
          <div
            className="animate-fade-in-slow max-w-[280px] opacity-0"
            style={{
              animationDelay: getAnimationDelay(3),
              animationFillMode: "forwards",
            }}
          >
            <Typography variant="body-sm" color="secondary">
              {t("ai_spaces_summaries.no_posts_found")}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  </div>
);
